<template>
  <b-form-group
    :label="inputLabel"
    :label-for="inputName"
    v-slot="{ ariaDescribedby }"
    class="d-block"
  >
    <b-form-checkbox-group
      v-model="computedSelectedDays"
      class="custom-checkbox-grid mt-1"
      :options="dayOfWeeksEnum"
      :aria-describedby="ariaDescribedby"
      :name="inputName"
      :id="inputName"
    ></b-form-checkbox-group>
  </b-form-group>
</template>

<script>
export default {
  props: {
    inputLabel: {
      type: String,
      default: "روز های مورد نظر را انتخاب کنید",
    },
    inputName: {
      type: String,
      default: "WeekDaysCheckBoxGroup",
    },
    value: {
      required: false,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      dayOfWeeksEnum: [
        {
          text: "شنبه",
          value: 6,
        },
        {
          text: "یکشنبه",
          value: 0,
        },
        {
          text: "دوشنبه",
          value: 1,
        },
        {
          text: "سه‌شنبه",
          value: 2,
        },
        {
          text: "چهارشنبه",
          value: 3,
        },
        {
          text: "پنجشنبه",
          value: 4,
        },
        {
          text: "جمعه",
          value: 5,
        },
      ],
    };
  },
  computed: {
    computedSelectedDays: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  components: {
    BFormGroup,
    BFormCheckboxGroup,
  },
};
import { BFormGroup, BFormCheckboxGroup } from "bootstrap-vue";
</script>
<style scoped>
@media only screen and (max-width: 768px) {
  .custom-checkbox-grid {
    display: grid;
    grid-template-columns: auto auto auto;
    gap: 5px 0;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .custom-checkbox-grid {
    display: grid;
    grid-template-columns: auto auto auto auto;
    gap: 5px 0;
  }
}
@media only screen and (min-width: 1025px) {
  .custom-checkbox-grid {
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    gap: 5px 0;
  }
}
</style>
